import type { BaseEntity } from './BaseEntity';
import type { InventoryItem } from './InventoryItem';
import { ProductItem } from './ProductItem';

export enum UnitType {
  POUND = 'POUND',
  ITEM = 'ITEM',
  OUNCE = 'OUNCE'
}

export interface Item extends BaseEntity {
  name: string;
  unitType: UnitType;
  isIngredient: boolean;
  description?: string | undefined;
  orderNotes?: string;
  standardShippingQuantity?: number;
  minOrderQuantity?: number;
  maxOrderQuantity?: number;
  inventoryItems?: InventoryItem[];
  productItems?: ProductItem[];
  outOfStock?: boolean;
  lowStock?: boolean;
  totalQuantityOnHand?: number;
  averageCostPerUnit?: number;
}

type ValidationResult = { issues: { message: string; path: (keyof Item)[] }[] };

export function validate(item: Partial<Item>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!item.name) {
    issues = [...issues, { message: 'Name is required', path: ['name'] }];
  }

  return { issues };
}

export const unitTypeToUnits = (unitType: UnitType | undefined) => {
  switch (unitType) {
    case UnitType.ITEM: {
      return '';
    }
    case UnitType.OUNCE: {
      return 'oz';
    }
    default:
    case UnitType.POUND: {
      return 'lbs';
    }
  }
}

export const unitTypeToUnit = (unitType: UnitType | undefined) => {
  switch (unitType) {
    case UnitType.ITEM: {
      return 'item';
    }
    case UnitType.OUNCE: {
      return 'oz';
    }
    default:
    case UnitType.POUND: {
      return 'lb';
    }
  }
}